var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKubernetesServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2.94,
    y1: 3.74,
    x2: 8.67,
    y2: 3.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773adc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 9.13,
    y1: 3.79,
    x2: 14.85,
    y2: 3.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773adc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.01,
    y1: 9.12,
    x2: 5.73,
    y2: 9.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773adc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 6.18,
    y1: 9.08,
    x2: 11.9,
    y2: 9.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773adc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 12.35,
    y1: 9.13,
    x2: 18.08,
    y2: 9.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773adc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 2.87,
    y1: 14.56,
    x2: 8.6,
    y2: 14.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773adc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 9.05,
    y1: 14.6,
    x2: 14.78,
    y2: 14.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773adc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M5.8 1.22l-2.86.53v3.9l2.86.61 2.87-1.15V2.2L5.8 1.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91 6.2l2.62-1.06A.2.2 0 008.65 5V2.36a.21.21 0 00-.13-.18l-2.65-.9h-.12l-2.6.48a.2.2 0 00-.15.18v3.53a.19.19 0 00.15.19l2.63.55a.32.32 0 00.13-.01z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94 1.75v3.9l2.89.61v-5zm1.22 3.6l-.81-.16v-3l.81-.13zm1.26.23l-.93-.15V2l.93-.16z",
    fill: "#341a6e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M11.99 1.27l-2.86.53v3.9l2.86.61 2.86-1.16v-2.9l-2.86-.98z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13 1.8v3.9l2.87.61v-5zm1.21 3.6l-.81-.16v-3l.81-.13zm1.26.23l-.93-.15V2.05l.93-.17z",
    fill: "#341a6e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M2.87 6.6l-2.86.53v3.9l2.86.61 2.87-1.15V7.58L2.87 6.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.13V11l2.89.61v-5zm1.21 3.61l-.81-.17v-3l.81-.14zm1.27.26l-.93-.15V7.38l.93-.16z",
    fill: "#341a6e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M9.04 6.56l-2.86.53v3.9l2.86.62 2.86-1.16V7.54l-2.86-.98z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18 7.09V11l2.88.61v-5zm1.21 3.61l-.81-.17v-3l.81-.14zm1.26.22l-.93-.15V7.34l.93-.16z",
    fill: "#341a6e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M15.21 6.61l-2.86.53v3.9l2.86.61 2.87-1.15V7.59l-2.87-.98z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.35 7.14V11l2.89.61v-5zm1.22 3.61l-.81-.17v-3l.81-.14zm1.26.22l-.93-.15V7.39l.93-.16z",
    fill: "#341a6e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M5.73 12.04l-2.86.52v3.9l2.86.62 2.87-1.16v-2.9l-2.87-.98z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84 17l2.61-1a.18.18 0 00.12-.18v-2.6a.2.2 0 00-.13-.22l-2.64-.9a.17.17 0 00-.12 0l-2.6.47a.19.19 0 00-.16.19v3.54a.19.19 0 00.15.19L5.7 17a.23.23 0 00.14 0z",
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87 12.56v3.9l2.89.62V12zm1.22 3.61L3.28 16v-3l.81-.14zm1.26.23l-.93-.15v-3.44l.93-.16z",
    fill: "#341a6e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M11.91 12.08l-2.86.53v3.9l2.86.61 2.87-1.15v-2.91l-2.87-.98z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05 12.61v3.9l2.89.61v-5zm1.22 3.61l-.81-.17v-3l.81-.14zm1.26.22l-.93-.15v-3.43l.93-.16z",
    fill: "#341a6e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKubernetesServices);
export default __webpack_public_path__ + "static/media/Kubernetes-Services.9546027c9b073b538d0f2f0070184d57.svg";
export { ForwardRef as ReactComponent };